import { QueryClientProvider as QueryClientProviderShared } from '@tv2/lib-graphql/client';
import { PropsWithChildren, useMemo } from 'react';
import { useClient } from './useClient';
import { CreateClientOptions } from './graphqlClient';
import { useUpdateUser, useUser } from '../user/UserProvider';

export function QueryClientProvider({
  apiUrl,
  children,
  isAdmin,
}: PropsWithChildren<{
  apiUrl: string;
  isAdmin: boolean | undefined;
}>) {
  const { completed, accessToken } = useUser();
  const { updateAccessToken } = useUpdateUser();

  const options = useMemo<CreateClientOptions>(
    () => ({
      url: apiUrl,
      accessToken,
      updateAccessToken,
      isAdmin,
      ready: completed,
    }),
    [apiUrl, accessToken, updateAccessToken, isAdmin, completed]
  );

  const client = useClient(options);

  return <QueryClientProviderShared client={client}>{children}</QueryClientProviderShared>;
}
